import React from 'react';
import { IQRCodeScennerProps } from '../../types/PropTypes';
import QRCodeScanner from '../../components/shared/QRCodeScanner';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';
class QRCodeScannerPage extends React.Component<IQRCodeScennerProps> {
    render() {
        const { t } = this.props;
        return (
            <>
                <a className="logo" href="/" title={companyNameReplace(t('login.button.instavolt'))}>
                    <img
                        className="d-block"
                        src={images.logoPNG}
                        alt={companyNameReplace(t('login.button.instavolt'))}
                    />
                </a>
                <div className="login-block">
                    <div className="title-outer pb-3">
                        <h1 className="title pb-2">{t('login.qrCode.header')}</h1>
                        <p>{t('login.qrCode.subheader')}</p>
                    </div>
                    <QRCodeScanner {...this.props} />
                </div>
            </>
        );
    }
}

export default QRCodeScannerPage;
